/* eslint-disable */
import React, { useEffect, useState } from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Members/FileInput.style.css";
import PlusIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Plus.svg";
import PropTypes from "prop-types";

const FileInput = ({
  label,
  name,
  setFieldValue,
  placeholder,
  value,
  className = "",
}) => {
  const [preview, setPreview] = useState();
  const selectedImage = (event) => {
    if (event.target.files.length > 0) {
      const previewUrl = URL.createObjectURL(event.target.files[0]);
      setPreview(previewUrl);
    } else {
      setPreview("");
    }
  };
  return (
    <div className={`fileUploadInputSection ${className}`}>
      <label htmlFor={label}>{label}</label>
      <div className="fileUploadInputContainer">
        <img src={PlusIcon} alt="" />
        {preview !== "" ? (
          <img src={preview} alt="" className="fileInputPreviewImage" />
        ) : (
          ""
        )}
        <h3>{placeholder}</h3>
        <input
          type="file"
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(event) => {
            selectedImage(event);
            setFieldValue(event.target.files[0]);
          }}
        />
      </div>
    </div>
  );
};

export default FileInput;
FileInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
